import { graphql } from 'react-relay';

/**
 * Corpo data fragment shared by layout.js and FidelityProgramCard.js.
 * Lives in its own module (named after the fragment, as Relay requires) to break the
 * layout <-> FidelityProgramCard import cycle.
 */
// eslint-disable-next-line import/prefer-default-export
export const fragmentCorpoData = graphql`
  fragment layoutCorpoData on Corpo {
    ref
    name
    fidelityLevel
    isFidelityActive
    subscription
    fidelityProgress {
      year
      yearBookings
      bookingsToNextTier
      bookingsToMaintain
      validUntil
    }
    teamName
    formatted_address
    siret
    tvaNumber
    invoiceEmails
    params {
      allowEmailDomain
      automaticApprouval
      manualApprouval
      automaticDeniedOtherEmailDomain
      manualOtherEmailDomain
    }
    payment {
      isSepa
      transferMode
      mandateUrl
    }
    users {
      ref
      roles
      status
      email
      user {
        email
        lastname
        firstname
      }
      adminNeedValid: is(what: NEEDAPPROVAL)
      emails {
        template
        limitDate
      }
    }
  }
`;
